module.exports = __webpack_public_path__ + "img/icons B_22.3272ccec.svg";